import { ReactNode, forwardRef } from 'react';

import { Stack } from '@mui/material';
import cx from 'classnames';

import styles from './PanelContent.module.scss';

export interface PanelContentProps {
  children: ReactNode;
  className?: string;
  hideOverflow?: boolean;
  hasPaddingBottom?: boolean;
  constrainWidth?: boolean;
}

export const PanelContent = forwardRef<HTMLDivElement, PanelContentProps>(
  (
    {
      children,
      className,
      hideOverflow = false,
      hasPaddingBottom = true,
      constrainWidth = false,
    },
    ref,
  ) => (
    <div
      ref={ref}
      tabIndex={-1}
      className={cx(styles.Wrapper, className, {
        [styles.HideOverflow]: hideOverflow,
        [styles.PaddingBottom]: hasPaddingBottom,
      })}
    >
      <Stack
        className={cx(styles.Inner, {
          [styles.ConstrainWidth]: constrainWidth,
        })}
        gap={2}
      >
        {children}
      </Stack>
    </div>
  ),
);

PanelContent.displayName = 'PanelContent';
